import { SchedulerEntryRow } from '../SchedulerEntryRow';
import { ResultsTableProps } from './ResultsTable.types';
import './ResultsTable.css';

/**
 * Results table component displaying scheduler entries
 * Shows expandable entries with substages and inline editing capabilities
 *
 * Features:
 * - Expandable entry rows with substage details
 * - Mobile-responsive table layout
 * - Inline editing for entry and substage data
 * - Status-based row styling
 * - Action buttons for edit/save/cancel operations
 *
 * @param props - Component props containing entries and callbacks
 * @returns JSX element containing the results table
 */
export function ResultsTable({
  entries,
  expandedEntries,
  isMobile,
  bodyRef,
  onToggleExpanded,
  onStartEditing,
  onCancelEditing,
  onSaveEdit,
  onUpdateEditingValue,
  isEditing,
  getEditingValue,
  hasItemChanges
}: ResultsTableProps) {
  return (
    <div className={`scheduler-results-container ${isMobile ? 'mobile' : ''}`}>
      <div className="table-wrapper" ref={bodyRef}>
        <table className={`scheduler-results-table ${isMobile ? 'mobile-table' : ''}`}>
          <tbody>
            {entries.map((entry: any) => (
              <SchedulerEntryRow
                key={entry.id}
                entry={entry}
                isExpanded={expandedEntries.includes(entry.id)}
                onToggleExpanded={onToggleExpanded}
                onStartEditing={onStartEditing}
                onCancelEditing={onCancelEditing}
                onSaveEdit={onSaveEdit}
                onUpdateEditingValue={onUpdateEditingValue}
                isEditing={isEditing}
                getEditingValue={getEditingValue}
                hasItemChanges={hasItemChanges}
              />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
